export default "__VITE_ASSET__CoEHpndb__"